export function installObjectFromEntries() {
    if (!Object.fromEntries) {
        Object.defineProperty(Object, 'fromEntries', {
            value(entries: Iterable<readonly [PropertyKey, unknown]>) {
                return Array.from(entries).reduce<Record<PropertyKey, unknown>>((object, [key, value]) => {
                    object[key] = value;
                    return object;
                }, {});
            },
            configurable: true,
            writable: true,
        });
    }
}

installObjectFromEntries();
